var ArraymonthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'July',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

function getDaySuffix(n) {
  if (n >= 11 && n <= 13) {
    return 'th';
  }
  switch (n % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}

function formatDate(date) {
  var day = date.getDate();
  return ArraymonthNames[date.getMonth()] + ' ' + day + getDaySuffix(day);
}

document.addEventListener("DOMContentLoaded", () => {
  var deliveryEl = document.querySelector('.pdp-estimated-delivery');
  var productId = deliveryEl.dataset.productId;

  if (deliveryEl) {
    fetch(`https://webhooks.endrock.software/endrockapi/v3/app/estimatedArrival/?store=replenix&id=all`)
      .then((response) => response.json())
      .then((json) => {
        var getMaxDate = new Date(json.data?.delivery_max_date_at + ' 00:00:00');
        var getMinDate = new Date(json.data?.delivery_min_date_at + ' 00:00:00');
        var maxDate = formatDate(getMaxDate);
        var minDate = formatDate(getMinDate);
        if (!isNaN(getMaxDate.getDate())) {
          deliveryEl.innerHTML = `
          <svg class="pdp-estimated-delivery__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.29999C11.395 1.29999 10.838 1.44999 10.229 1.70199C9.64 1.94599 8.956 2.30499 8.105 2.75199L6.037 3.83699C4.992 4.38499 4.157 4.82399 3.51 5.25499C2.842 5.70199 2.326 6.17199 1.951 6.80899C1.577 7.44399 1.409 8.13199 1.328 8.95099C1.25 9.74599 1.25 10.723 1.25 11.953V12.147C1.25 13.377 1.25 14.354 1.328 15.149C1.409 15.969 1.578 16.656 1.951 17.291C2.326 17.928 2.841 18.398 3.511 18.845C4.156 19.276 4.992 19.715 6.037 20.263L8.105 21.348C8.956 21.795 9.64 22.154 10.229 22.398C10.839 22.65 11.395 22.8 12 22.8C12.605 22.8 13.162 22.65 13.771 22.398C14.36 22.154 15.044 21.795 15.895 21.348L17.963 20.264C19.008 19.715 19.843 19.276 20.489 18.845C21.159 18.398 21.674 17.928 22.049 17.291C22.423 16.656 22.591 15.968 22.672 15.149C22.75 14.354 22.75 13.377 22.75 12.147V11.953C22.75 10.723 22.75 9.74599 22.672 8.95099C22.591 8.13099 22.422 7.44399 22.049 6.80899C21.674 6.17199 21.159 5.70199 20.489 5.25499C19.844 4.82399 19.008 4.38499 17.963 3.83699L15.895 2.75199C15.044 2.30499 14.36 1.94599 13.771 1.70199C13.161 1.44999 12.605 1.29999 12 1.29999ZM8.77 4.09599C9.66 3.62899 10.284 3.30299 10.802 3.08899C11.306 2.87999 11.661 2.79999 12 2.79999C12.34 2.79999 12.694 2.87999 13.198 3.08899C13.716 3.30299 14.339 3.62899 15.229 4.09599L17.229 5.14599C18.319 5.71699 19.084 6.11999 19.657 6.50199C19.939 6.69099 20.16 6.86599 20.34 7.04199L17.009 8.70699L8.509 4.23299L8.77 4.09599ZM6.945 5.05399L6.771 5.14599C5.681 5.71699 4.916 6.11999 4.344 6.50199C4.09993 6.66021 3.87126 6.841 3.661 7.04199L12 11.212L15.357 9.53199L7.151 5.21399C7.0735 5.17311 7.00378 5.11896 6.945 5.05399ZM2.938 8.35699C2.888 8.57099 2.849 8.81399 2.821 9.09699C2.751 9.81099 2.75 10.714 2.75 11.991V12.108C2.75 13.386 2.75 14.289 2.821 15.002C2.89 15.699 3.021 16.15 3.244 16.53C3.466 16.907 3.787 17.226 4.344 17.598C4.916 17.98 5.681 18.383 6.771 18.954L8.771 20.004C9.661 20.471 10.284 20.797 10.802 21.011C10.966 21.079 11.113 21.133 11.25 21.176V12.513L2.938 8.35699ZM12.75 21.175C12.887 21.133 13.034 21.079 13.198 21.011C13.716 20.797 14.339 20.471 15.229 20.004L17.229 18.954C18.319 18.382 19.084 17.98 19.657 17.598C20.213 17.226 20.534 16.907 20.757 16.53C20.98 16.15 21.11 15.7 21.179 15.002C21.249 14.289 21.25 13.386 21.25 12.109V11.992C21.25 10.714 21.25 9.81099 21.179 9.09799C21.1565 8.849 21.1174 8.60178 21.062 8.35799L17.75 10.013V13.05C17.75 13.2489 17.671 13.4397 17.5303 13.5803C17.3897 13.721 17.1989 13.8 17 13.8C16.8011 13.8 16.6103 13.721 16.4697 13.5803C16.329 13.4397 16.25 13.2489 16.25 13.05V10.763L12.75 12.513V21.175Z" fill="#5E987D"/>
          </svg>
          <span class="pdp-estimated-delivery__text">
            Order today and recieve by: <span class="pdp-estimated-delivery__date">${minDate} - ${maxDate}</span>
          </span>
          `;
        }
      }).catch(error => console.error(error))
  }
});

document.addEventListener("DOMContentLoaded", () => {
  var deliveryEl = document.querySelector('.estimated-delivery-cart');
  var productId = deliveryEl.dataset.productId;

  if (deliveryEl) {
    fetch(`https://webhooks.endrock.software/endrockapi/v3/app/estimatedArrival/?store=replenix&id=all`)
      .then((response) => response.json())
      .then((json) => {
        var getMaxDate = new Date(json.data?.delivery_max_date_at + ' 00:00:00');
        var getMinDate = new Date(json.data?.delivery_min_date_at + ' 00:00:00');
        var maxDate = formatDate(getMaxDate);
        var minDate = formatDate(getMinDate);
        if (!isNaN(getMaxDate.getDate())) {
          deliveryEl.innerHTML = `
          <img src="https://cdn.shopify.com/s/files/1/0520/7221/8813/files/truck_1_1.svg?v=1701930172" alt="delivery-icon">
          <h3>Estimated Delivery: <span class="pdp-estimated-delivery__text"><span class="pdp-estimated-delivery__date">${minDate} - ${maxDate}</span></span></h3>
          `;
        }
      }).catch(error => console.error(error))
  }
});